export default "__VITE_ASSET__mYUv1629__"